import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showMap: localStorage.getItem('isshowMap'),
    userInfo: "",
    deviceCount: 0,
    deviceKey: "",
    mapCenter: [],
    mapZoomSize: 0,
    currentItem: null,
    silderComponent: [],
    model:"",
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
     getCurrentItem(state) {
      return state.currentItem
    },
     getSilderComponent(state) {
      return state.silderComponent
    },
     getModel(state) {
      return state.model
    }
  },
  mutations: {
    setShowMap(state, data) {

      state.showMap = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setDeviceCount(state, data) {
      state.deviceCount = data
    },
    setDeviceKey(state, data) {
      state.deviceKey = data
    },
    setMapCenter(state, data) {
      state.mapCenter = data
    },
    setMapZoomSize(state, data) {
      state.mapZoomSize = data
    },
     setCurrentItem(state, data) {
      state.currentItem = data
    },
    setSilderComponent(state, data) {
      state.silderComponent = data
    },
   setModel(state, data) {
      state.model = data
    }
  },
  actions: {},
  modules: {},
});
